<ng-container *ngIf="(isHandheld$ | async) !== true">
  <div edsGrid edsSpacing="xl" *ngFor="let grid of grids$ | async">
    <div class="container container--wide">
      <ag-grid-angular
        #ratingsGrid
        class="ag-theme-frk"
        [columnDefs]="grid.colDefs"
        [defaultColDef]="defaultColDef"
        [rowData]="grid.rowData"
        [frameworkComponents]="frameworkComponents"
        [groupHeaderHeight]="64"
        domLayout="autoHeight"
        style="width: 100%; height: 100%"
        [pagination]="false"
        [suppressPaginationPanel]="true"
        [suppressDragLeaveHidesColumns]="true"
        [suppressRowHoverHighlight]="true"
        [enableCellTextSelection]="true"
        (sortChanged)="onSortChanged()"
        (gridReady)="onGridReady()"
        (columnResized)="onColumnResized()"
      >
      </ag-grid-angular>
    </div>
  </div>
</ng-container>

<grid edsGrid *ngIf="isHandheld$ | async">
  <div edsRow edsSpacing="xl" *ngFor="let grid of grids$ | async">
    <div edsCol>
      <eds-section-header
        [title]="grid.morningStarCategory"
        size="h6"
        [level]="3"
        caveatPlacement="Fund Morningstar:RatingsTitle"
        [tooltip]="titleTooltip"
        edsSpacing="lg"
      ></eds-section-header>
      <div *ngFor="let card of grid.cards">
        <ft-ppss-card edsSpacing="base" [data]="card"></ft-ppss-card>
      </div>
    </div>
  </div>
</grid>
